<template>
    <v-container>
        <loading-component :value="loading"/>
        <v-layout row wrap>
            <v-flex xs12 class="display-1 text-xs-center" style="padding-bottom: 4px;border-bottom: 1px solid black;">
                AI KPIs
            </v-flex>
            <v-flex xs6 class="pa-1">
                <choose-date label="From" v-model="form.from"/>
            </v-flex>
            <v-flex xs6 class="pa-1">
                <choose-date label="To" v-model="form.to"/>
            </v-flex>
            <v-flex xs3 class="pa-1">
                <v-select multiple :items="['REALTIME','SCHEDULED','ETA']"
                          v-model="form.booking_types"
                          label="Bookings Types"/>
            </v-flex>
            <v-flex xs6 class="pa-1">
                <v-select multiple :items="['CC','CC_SAME_AI','CC_NOT_SAME_AI','AI']"
                          v-model="form.dispatch_types"
                          label="Dispatch Types"/>
            </v-flex>
            <v-flex xs3 class="pa-1">
                <choose-captain-multi :multi="false" v-model="form.captain_id" label="Custom Captain"/>
            </v-flex>
            <v-flex xs4 offset-xs5>
                <v-btn color="primary" @click="update">
                    REFRESH
                </v-btn>
            </v-flex>
            <v-flex xs12 class="pa-2">
                <v-layout row wrap class="subheading">
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Dispatches: <span class="font-weight-bold">{{parseInt(data.dispatches)}}</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Percentage: <span class="font-weight-bold">{{parseFloat(data.percentage) * 100}} %</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Reject Rate: <span class="font-weight-bold">{{parseFloat(data.reject_rate) * 100}} %</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Average Pickup Lateness: <span class="font-weight-bold">{{parseFloat(data.avg_lateness)}}</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Average Elapsed Time: <span
                            class="font-weight-bold">{{parseFloat(data.avg_elapsed_time)}}</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Average Drop Off Lateness : <span
                            class="font-weight-bold">{{parseFloat(data.avg_drop_off_lateness)}}</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Average Ghost Ride : <span
                            class="font-weight-bold">{{parseFloat(data.avg_ghost_ride)}}</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Suggestions Count : <span
                            class="font-weight-bold">{{parseInt(data.suggestions_count)}}</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Unsent Suggestions : <span
                            class="font-weight-bold">{{parseInt(data.unsent_suggestions_count)}}</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Sent Suggestions : <span
                            class="font-weight-bold">{{parseInt(data.sent_suggestions_count)}}</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Accepted Suggestions : <span
                            class="font-weight-bold">{{parseInt(data.accepted_suggestions_count)}}</span>
                    </v-flex>
                    <v-flex xs6 sm4 md3 class="pa-1">
                        Refused Suggestions : <span
                            class="font-weight-bold">{{parseInt(data.refused_suggestions_count)}}</span>
                    </v-flex>

                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import LoadingComponent from "@/components/LoadingComponent";
    import ChooseCaptainMulti from "@/components/wasilni/input/ChooseCaptainMulti";

    export default {
        components: {LoadingComponent, ChooseDate, ChooseCaptainMulti},
        title: "Ai Stats",
        name: "ai-stats",
        data() {
            return {
                loading: false,
                form: {
                    from: moment().subtract("7", "days").format("YYYY-MM-DD"),
                    to: moment().format("YYYY-MM-DD"),
                    booking_types: ['REALTIME', 'SCHEDULED', 'ETA'],
                    dispatch_types: ['CC', 'CC_SAME_AI', 'CC_NOT_SAME_AI', 'AI'],
                    captain_id: null
                },
                data: {
                    dispatches: 0,
                    percentage: 0,
                    avg_lateness: 0,
                    avg_elapsed_time: 0,
                    avg_drop_off_lateness: 0,
                    avg_ghost_ride: 0,
                    suggestions_count: 0,
                    unsent_suggestions_count: 0,
                    sent_suggestions_count: 0,
                    accepted_suggestions_count: 0,
                    refused_suggestions_count: 0,
                    reject_rate: 0
                }
            }
        },
        methods: {
            update() {
                this.loading = true;
                this.axios.post("statistics/ai_stats", this.form)
                    .then(
                        ({data: {data}}) => {
                            this.data = data;
                        }
                    )
                    .finally(
                        () => this.loading = false
                    )
            }
        },
        mounted() {
            this.update();
        }
    }
</script>

<style scoped>

</style>